import * as React from 'react';
import styled from 'styled-components';
import { FlexRowCenterVertical } from '../../..';
import { Select } from '../General/Select';
import { rem } from 'polished';

interface Props {
  handleChange: any;
  displayNumber: string;
  text: string;
  customOptions?: Array<{ value: string; name: string }>;
}

function CategoryProductsOnPage({
  handleChange,
  displayNumber,
  text,
  customOptions,
}: Props) {
  return (
    <Wrapper>
      <Label>{text}</Label>
      <SelectWrapper>
        <Select
          name="number_of_products_on_page"
          label={''}
          value={displayNumber}
          options={
            customOptions
              ? customOptions
              : [
                  { value: '18', name: '18' },
                  { value: '36', name: '36' },
                  { value: '54', name: '54' },
                ]
          }
          // tslint:disable-next-line:jsx-no-lambda
          onChange={handleChange}
          marginBottom={16}
          marginRight={0}
          mobileMarginBottom={16}
          mobileMarginRight={10}
        />
      </SelectWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(FlexRowCenterVertical)`
  width: auto;
  min-width: 230px;
  justify-content: flex-end;
  ${({ theme }) => theme.mediab.m580`
    justify-content: space-between
  `}
`;
const SelectWrapper = styled.div`
  width: ${rem(65)};
  margin-left: ${rem(12)};
  ${({ theme }) => theme.mediab.m580`
    width: ${rem(80)};
  `}
`;

const Label = styled.span`
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: ${rem(14)};
  line-height: ${rem(28)};
  margin-bottom: ${rem(18)};
`;

export { CategoryProductsOnPage };
